import styled from 'styled-components';

const SendToInforMenuWrapper = styled.div`
  > div {
    padding: 0;
    border: 0;
  }
`;
const SendToInforItem = styled.div`
  width: 14.1rem;
  height: 4rem;
  padding: 1rem 1.2rem;
  text-align: left;
  :hover {
    background: ${(props): string => props.theme.colors.marinoBlue};
    color: ${(props): string => props.theme.colors.pureWhite};
    cursor: pointer;
  }
`;

export { SendToInforItem, SendToInforMenuWrapper };
